export default __webpack_public_path__ + "static/media/restful.28d6c3af.png";